<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50">
        <defs>
            <clipPath id="clip-Phone">
                <rect width="50" height="50"/>
            </clipPath>
        </defs>
        <g id="Phone" clip-path="url(#clip-Phone)">
            <g id="Groupe_3103" data-name="Groupe 3103" transform="translate(15 7)">
                <path id="Tracé_2997" data-name="Tracé 2997" d="M3.745,0H17.17a3.761,3.761,0,0,1,3.745,3.745V32.97a3.761,3.761,0,0,1-3.745,3.745H3.745A3.761,3.761,0,0,1,0,32.97V3.745A3.761,3.761,0,0,1,3.745,0ZM1.279,28.906H19.636V7.809H1.279Zm18.357,1.279H1.279V32.97a2.5,2.5,0,0,0,2.466,2.512H17.17a2.5,2.5,0,0,0,2.466-2.512ZM1.279,6.576H19.636V3.745A2.456,2.456,0,0,0,17.17,1.279H3.745A2.456,2.456,0,0,0,1.279,3.745Z" :fill="color"/>
                <path id="Tracé_2998" data-name="Tracé 2998" d="M129.116,77.279a.64.64,0,0,1,0-1.279h7.946a.64.64,0,0,1,0,1.279Z" transform="translate(-122.632 -72.529)" :fill="color"/>
                <path id="Tracé_2999" data-name="Tracé 2999" d="M193.827,674a1.881,1.881,0,0,1,1.872,1.872,1.85,1.85,0,1,1-3.7,0A1.872,1.872,0,0,1,193.827,674Z" transform="translate(-183.232 -643.222)" fill-rule="evenodd" :fill="color"/>
            </g>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconPhone',
    mixins: [Colorable],
};
</script>

